/**
 * Product Accordion
 * Desktop (768px+): Content floats upward as overlay
 * Mobile (<768px): Standard collapsible, content opens below and pushes down
 */

(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }

  function initAccordion() {
    const accordionItems = document.querySelectorAll('.accordion-item');
    if (!accordionItems.length) return;

    accordionItems.forEach(function(item) {
      const trigger = item.querySelector('.accordion-trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        toggleAccordion(item);
      });

      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleAccordion(item);
        }
      });
    });

    function isDesktop() {
      return window.innerWidth >= 768;
    }

    function toggleAccordion(item) {
      if (item.classList.contains('active')) {
        closeAccordion(item);
      } else {
        closeAllAccordions();
        openAccordion(item);
      }
    }

    function openAccordion(item) {
      const trigger = item.querySelector('.accordion-trigger');
      const overlay = item.querySelector('.accordion-overlay');
      const overlayContent = item.querySelector('.accordion-overlay-content');
      if (!overlay || !overlayContent) return;

      item.classList.add('active');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');

      // Both mobile and desktop use scrollHeight for smooth animation
      // CSS handles positioning (static on mobile, absolute on desktop)
      overlay.style.maxHeight = (overlayContent.scrollHeight + 40) + 'px';
    }

    function closeAccordion(item) {
      const trigger = item.querySelector('.accordion-trigger');
      const overlay = item.querySelector('.accordion-overlay');
      if (!overlay) return;

      item.classList.remove('active');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      overlay.style.maxHeight = '0';
    }

    function closeAllAccordions() {
      accordionItems.forEach(function(item) {
        if (item.classList.contains('active')) closeAccordion(item);
      });
    }

    // Recalculate open accordion heights on resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        accordionItems.forEach(function(item) {
          if (item.classList.contains('active')) {
            const overlay = item.querySelector('.accordion-overlay');
            const overlayContent = item.querySelector('.accordion-overlay-content');
            if (overlay && overlayContent) {
              overlay.style.maxHeight = (overlayContent.scrollHeight + 40) + 'px';
            }
          }
        });
      }, 250);
    });
  }

})();